import React from "react";
import { Crown, X } from "lucide-react";

export const OverallParticipants = ({ overallId, participants, winnerId, onRemove }) => (
  <table className="table-dense" data-testid={`overall-participants-${overallId}`}>
    <thead>
      <tr>
        <th>Categoria de origem</th>
        <th>Nº</th>
        <th>Atleta</th>
        <th>Equipe</th>
        <th>Entrada</th>
        <th className="text-right pr-2"></th>
      </tr>
    </thead>
    <tbody>
      {participants.length === 0 && (
        <tr><td colSpan={6} className="text-center text-[var(--text-secondary)] py-4">Nenhum atleta neste Overall ainda.</td></tr>
      )}
      {participants.map((p) => {
        const isWinner = p.athlete_id && p.athlete_id === winnerId;
        return (
          <tr key={p.athlete_id || `empty-${p.category_id}`} className={isWinner ? "bg-[#C9A84C]/10" : ""} data-testid={`overall-row-${overallId}-${p.athlete_id || p.category_id}`}>
            <td className="text-xs">{p.categoria}{p.origem === "manual" && p.posicao ? <span className="text-[var(--text-secondary)]"> · {p.posicao}º</span> : null}</td>
            <td className="tabular-nums font-bold">{p.numero ?? "—"}</td>
            <td className="flex items-center gap-2">
              {isWinner && <Crown size={14} className="text-[#C9A84C]" data-testid={`overall-winner-crown-${overallId}`} />}
              {p.nome ?? <span className="text-[var(--text-secondary)] italic">sem campeão definido</span>}
            </td>
            <td className="text-xs text-[var(--text-secondary)]">{p.equipe || "—"}</td>
            <td>
              {p.athlete_id && (
                <span className={`text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded-sm border ${p.origem === "campeao" ? "border-[#C9A84C]/50 text-[#C9A84C]" : "border-white/20 text-[var(--text-secondary)]"}`}>
                  {p.origem === "campeao" ? "Campeão" : "Manual"}
                </span>
              )}
            </td>
            <td className="text-right pr-2">
              {p.athlete_id && (
                <button type="button" className="btn-ghost !p-1" title="Remover do Overall" onClick={() => onRemove(p.athlete_id)} data-testid={`overall-remove-${overallId}-${p.athlete_id}`}>
                  <X size={13} />
                </button>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
);
